<button type="button" class="sb-botao" [class.sb-vazio]="!service.base?.cnpj" (click)="abrir()" [title]="rotulo">
  <i class="pi pi-database"></i>
  <span>{{ rotulo }}</span>
  <i class="pi pi-angle-down"></i>
</button>

<p-dialog header="Base da prévia" [(visible)]="mostrar" [modal]="true" [style]="{ width: '640px' }">
  <div class="sb-form">
    <p class="sb-dica">
      Prévia, "Detectar colunas" e plano de execução rodam nesta base, numa transação somente leitura. Cada uso fica registrado no log da
      Central.
    </p>

    <div class="sb-linha">
      <div class="sb-campo">
        <label for="sb-cnpj">Cliente</label>
        <p-autoComplete inputId="sb-cnpj" [ngModel]="cnpj" (ngModelChange)="digitar($event)" [suggestions]="sugestoes" (completeMethod)="buscar($event.query)"
          (onSelect)="escolher($event)" (keyup.enter)="testar()" field="cnpj" [autoHighlight]="true" [delay]="300" [minLength]="2" appendTo="body" [showEmptyMessage]="true"
          emptyMessage="Nenhum cliente encontrado na Central. Com o CPF/CNPJ completo, Testar conecta direto no banco."
          placeholder="Nome ou CPF/CNPJ" styleClass="sb-auto" panelStyleClass="bc-painel">
          <ng-template let-c pTemplate="item">
            <div class="sb-item">
              <span class="sb-item-nome">{{ c.nome }}</span>
              <span class="sb-item-sub">{{ formatar(c.cnpj) }} · {{ c.host ? 'banco ' + c.banco + ' em ' + (c.servidor || c.host) : 'banco ' + c.banco }}</span>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <div class="sb-campo">
        <label for="sb-host">Servidor (opcional)</label>
        <input id="sb-host" type="text" pInputText [(ngModel)]="host" placeholder="o do cadastro de bancos" (keyup.enter)="testar()" />
      </div>
      <button pButton type="button" label="Testar" icon="pi pi-bolt" class="sb-testar" [loading]="testando" (click)="testar()"></button>
    </div>

    <div class="sb-cliente" *ngIf="cliente?.nome">
      <i class="pi pi-user"></i>
      <span><strong>{{ cliente.nome }}</strong> · {{ formatar(cliente.cnpj) }}</span>
    </div>

    <div class="sb-erro" *ngIf="erro">{{ erro }}</div>

    <ng-container *ngIf="teste">
      <div class="sb-ok">
        <i class="pi pi-check-circle"></i>
        <span>
          Conectou em <strong>{{ teste.banco }}</strong> no servidor <strong>{{ teste.host }}</strong>
          <ng-container *ngIf="teste.hostDoCadastro">(do cadastro de bancos)</ng-container>
          <ng-container *ngIf="teste.nome"> · {{ teste.nome }}</ng-container>
        </span>
      </div>

      <div class="sb-empresas-titulo">Empresas usadas no <code>:empresas</code> <small>(nenhuma marcada = todas)</small></div>
      <div class="sb-empresas">
        <div class="sb-empresa" *ngFor="let e of teste.empresas">
          <p-checkbox [inputId]="'sb-emp-' + e.id" [value]="e.id" [(ngModel)]="empresasEscolhidas"></p-checkbox>
          <label [for]="'sb-emp-' + e.id"><strong>{{ e.id }}</strong> · {{ e.nome }} <small>{{ e.cnpj }}</small></label>
        </div>
        <div class="sb-dica" *ngIf="!teste.empresas?.length">Nenhuma empresa ativa nesta base.</div>
      </div>
    </ng-container>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="mostrar = false"></button>
    <button pButton type="button" label="Usar esta base" icon="pi pi-check" [disabled]="!teste" (click)="usar()"></button>
  </ng-template>
</p-dialog>
